module.exports = __webpack_public_path__ + "img/20_dice[13].6cfcd03c.png";